import script from "./PostDisbursementChangesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDisbursementChangesTable.vue?vue&type=script&setup=true&lang=ts"

import "./PostDisbursementChangesTable.vue?vue&type=style&index=0&id=6d03a398&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d03a398"]])

export default __exports__